const discardChangesRemote = ({
  data: {
    blocks,
    chapterTitle,
    chapterTitleLocales,
    order,
    publishDate,
    updatedAt
  }
}) => {
  return {
    editorBlocks: blocks,
    editorBlocksOrder: order,
    editorChapterTitle: chapterTitle,
    editorChapterTitleIsEdited: false,
    editorChapterTitleLocales: chapterTitleLocales,
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorIsDisabled: false,
    editorIsDiscarding: false,
    editorIsDraft: false,
    editorPublishDate: publishDate
  };
};

export default discardChangesRemote;
